import { Component, DestroyRef, ViewChild, inject } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ActivatedRoute } from '@angular/router'
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, FeatureType } from '../../shared'
import { VehicleInspectionDashboardComponent } from './vehicle-inspection-dashboard.component'
import { VehicleInspectionListComponent } from './vehicle-inspection-list.component'

@Component({
    templateUrl: './vehicle-inspection.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        VehicleInspectionDashboardComponent,
        VehicleInspectionListComponent,
    ],
})
export class VehicleInspectionComponent extends BaseComponent {
    private route = inject(ActivatedRoute)
    private destroyRef = inject(DestroyRef)

    @ViewChild(VehicleInspectionDashboardComponent)
    dashboard?: VehicleInspectionDashboardComponent

    @ViewChild(VehicleInspectionListComponent)
    list?: VehicleInspectionListComponent

    activeTab = 0

    constructor() {
        super()
        // Users without dashboard access land directly on the Records tab.
        this.activeTab = this.canViewDashboard ? 0 : 1

        this.route.queryParamMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
            if (params.get('openInspectionId')) {
                this.activeTab = 1
            }
        })

        this.initialLoadingComplete()
    }

    tabChanged() {
        if (this.isDashboardTab) {
            this.dashboard?.refresh()
        }
    }

    onAddForEquipment(event: { equipmentCode: string; description: string }) {
        void this.list?.openAddForEquipment(event.equipmentCode)?.then(() => {
            this.dashboard?.refresh()
        })
    }

    get canViewDashboard() {
        return this.services.authentication.hasFeature([FeatureType.SafetyVehicleInspectionDashboardView])
    }

    get isDashboardTab() {
        return Number(this.activeTab) === 0
    }

    get isRecordsTab() {
        return Number(this.activeTab) === 1
    }
}
